// React
import { useContext, useEffect } from "react"

// Contexts
import { type CompanyType, CompanyContext } from "contexts"

// Third-Party Libraries
import { Outlet, useLoaderData } from "react-router-dom"

export function CompanyLayout(): JSX.Element {
  // Hooks
  const data = useLoaderData() as CompanyType
  const { assignCompany } = useContext(CompanyContext)

  useEffect(() => {
    assignCompany(data)
    // eslint-disable-next-line
  }, [])

  return <Outlet />
}